import { render, staticRenderFns } from "./ReschedulingRestructuring.vue?vue&type=template&id=afdb378e"
import script from "./ReschedulingRestructuring.vue?vue&type=script&lang=js"
export * from "./ReschedulingRestructuring.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/stage.cashnow.d-resources.com/releases/67404460/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('afdb378e')) {
      api.createRecord('afdb378e', component.options)
    } else {
      api.reload('afdb378e', component.options)
    }
    module.hot.accept("./ReschedulingRestructuring.vue?vue&type=template&id=afdb378e", function () {
      api.rerender('afdb378e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/views/customers/view/ReschedulingRestructuring.vue"
export default component.exports